module.exports = __webpack_public_path__ + "static/media/mais-laranja.de482485.png";